const data = {
  text: 'Jetzt Solarstrom-Check starten',
  subline: 'Dauer ca. 60 Sekunden',
  link: '100% kostenlos & unverbindlich',
  scrollTo: 'configurator'
}

export default data
